import "../styles/is.css";
import AOS from "aos";
import "aos/dist/aos.css";

import sub0101 from "../assets/sub0101-img01.jpg";
import { useEffect } from "react";

function OverView() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      offset: 100,
      easing: "ease-in-out",
      once: false,
    });

    window.addEventListener("scroll", () => {
      AOS.refresh();
    });
  }, []);

  return (
    <div>
      <section className="sec-wrap">
        <section className="sec-centent">
          <div id="sub" className="overview">
            <div className="col-a cont-wr">
              <div className="wr">
                <div className="cont-tit">
                  <h2 className="big">
                    좋은 인간·좋은 환경·좋은 기술로
                    <br /> 언제나 고객의 요구에 한 발자국 앞서갑니다.
                  </h2>
                  <p>
                    제닉스는 '고객만족'과 '인간존중'을 기업 경영의 가장 큰
                    이념으로 삼는 농림 정보화 전문 기업으로서
                    <br className="pc-only" />
                    안정적인 경영과 사업추진 역량강화로, 고객에게 효율적인
                    최적의 정보서비스를 제공하는데 노력해 왔습니다.
                  </p>
                </div>
              </div>
              <div
                className="img center"
                data-aos="fade"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                <img src={sub0101} alt="숲 속 길" />
              </div>
              <div className="wr">
                <p className="des">
                  자연과 환경, 인간이 함께 하는 제닉스는 고객 여러분에게
                  오래도록 사랑과 신뢰를 받는 기업이 되도록 최선을 다하겠습니다.
                  <br />
                  {/* <p className="des"> */}
                  저희 제닉스에 앞으로도 고객 여러분의 끊임없는 관심과 성원을
                  부탁드리며
                  <br className="pc-only" /> 저희도 고객의 눈으로 다시한번
                  생각하고 고객으로부터 최고의 신뢰를 받는 기업이 되기위해
                  끊임없는 노력을 경주하겠습니다.
                </p>
              </div>
            </div>
            <div className="col-c cont-wr">
              <div className="wr">
                <div className="cont-tit">
                  <small>OVERVIEW</small>
                  <h2>신뢰를 바탕으로 동반 성장하여 고객의 새로운 가치 창조</h2>
                </div>
              </div>
              <div className="col-b">
                <div className="wr">
                  <ul className="ico-list">
                    <li>
                      <span className="tit">
                        <strong>기업명</strong>
                      </span>
                      <span className="des">주식회사 제닉스</span>
                    </li>
                    <li>
                      <span className="tit">
                        <strong>설립일</strong>
                      </span>
                      <span className="des">
                        <div>2004년 12월 23일</div>
                        <div>(사업시작 1996년 9월)</div>
                      </span>
                    </li>
                    <li>
                      <span className="tit">
                        <strong>업종</strong>
                      </span>
                      <span className="des">소프트웨어 개발</span>
                    </li>
                    <li>
                      <span className="tit">
                        <strong>주소</strong>
                      </span>
                      <span className="des">
                        <div>
                          서울시 영등포구 영신로 166 반도아이비밸리 413호
                        </div>
                      </span>
                    </li>
                    <li>
                      <span className="tit">
                        <strong>대표전화</strong>
                      </span>
                      <span className="des">02-861-4716</span>
                    </li>
                    <li>
                      <span className="tit">
                        <strong>사업분야</strong>
                      </span>
                      <span className="des">
                        시스템통합, 하드웨어 시스템,인터넷 정보 보안, <br />
                        JAVA 라이센스(azul)
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
}

export default OverView;
